import axios from 'axios';
import { API_BASE_URL } from '../../config';

// Holds the in-flight refresh request. When several requests fail with a 401
// at the same time, only the first one actually calls the endpoint; the rest
// await this same promise instead of firing their own refresh.
let inFlightRefresh = null;

export const getRefreshToken = () => localStorage.getItem('refresh_token');

export const clearTokens = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
};

/**
 * Exchanges the stored refresh token for a new access token and persists it.
 *
 * Uses a bare axios call rather than apiRequest, which would recurse back
 * into the 401 handler that called this.
 *
 * @returns {Promise<string>} The new access token.
 */
export const refreshAccessToken = () => {
  if (inFlightRefresh) {
    return inFlightRefresh;
  }

  const refresh_token = getRefreshToken();
  if (!refresh_token) {
    return Promise.reject(new Error('No refresh token stored'));
  }

  inFlightRefresh = axios
    .post(
      `${API_BASE_URL}/common/token/refresh`,
      { refresh_token },
      { headers: { 'Content-Type': 'application/json' } }
    )
    .then((response) => {
      const { access_token } = response.data;
      localStorage.setItem('access_token', access_token);
      return access_token;
    })
    .catch((error) => {
      // The refresh token is expired, revoked, or the account is inactive.
      // Nothing is recoverable from here, so drop both tokens and let the
      // caller redirect to sign-in.
      clearTokens();
      throw error;
    })
    .finally(() => {
      inFlightRefresh = null;
    });

  return inFlightRefresh;
};
